import { render, staticRenderFns } from "./DialogueCenter.vue?vue&type=template&id=348330c9&"
import script from "./DialogueCenter.vue?vue&type=script&lang=js&"
export * from "./DialogueCenter.vue?vue&type=script&lang=js&"
import style0 from "./DialogueCenter.vue?vue&type=style&index=0&id=348330c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports